import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, NavigationEnd } from '@angular/router';
import { AuthService } from '../services/auth.service';
import * as CryptoJS from 'crypto-js';
import { environment } from '../environments/environments';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  // Array de rutas públicas que no requieren autenticación
  private publicRoutes: string[] = [
    '/data/dashboard-sync'  // Añadimos la ruta que queremos que sea pública
  ];

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const requestedRoute = state.url;

    console.log(requestedRoute)

    // Primero verificamos si la ruta solicitada es pública
    if (this.isPublicRoute(requestedRoute)) {
      return true; // Permitir acceso sin validación
    }

    const isAuthenticated = this.authService.isAuthenticated();
    const dynamicRoutes: string | null = localStorage.getItem('dynamicRoutes');

    if (!isAuthenticated) {
      this.router.navigate(['/login']);
      return false;
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const currentRoute = event.urlAfterRedirects;
      }
    });

    if (dynamicRoutes) {
      const parsedDynamicRoutes = JSON.parse(dynamicRoutes);
      const foundRoute = this.checkDynamicRouteExistence(parsedDynamicRoutes, requestedRoute);
      
      if (foundRoute) {
        return true;
      } else {
        this.router.navigate(['/access-denied']);
        return false;
      }
    } else {
      return false;
    }
  }

  // Nuevo método para verificar si una ruta es pública
  private isPublicRoute(route: string): boolean {
    return this.publicRoutes.some(publicRoute => 
      route.startsWith(publicRoute) || route === publicRoute
    );
  }

  private checkDynamicRouteExistence(dynamicRoutes: any[], requestedRoute: string): boolean {
    for (const route of dynamicRoutes) {
      if (CryptoJS.AES.decrypt('/' + route.path, environment.CryptoKey).toString() === 
          CryptoJS.AES.decrypt(requestedRoute, environment.CryptoKey).toString()) {
        return true;
      }

      if (route.children && Array.isArray(route.children)) {
        const foundRoute = this.checkDynamicRouteExistence(route.children, requestedRoute);
        if (foundRoute) {
          return true;
        }
      }
    }
    return false;
  }
}